import { getCardBrandFromFlagsGroup, useFlagGroup } from '@/contexts/flagsGroup'
import { useTonPlans } from '@/contexts/plans'
import { useReceivingOption } from '@/contexts/receivingOption'
import { PaymentsCard, ReceivingOptions } from '@/types/fees'
import { getPlanFeeByReceivingOptionAndFlag } from '@/utils/getPlanFeeByReceivingOptionAndFlag'

export function usePlanFees(planName?: string, rateFixed?: boolean) {
  const { flagsGroup } = useFlagGroup()
  const { receivingOption } = useReceivingOption()
  const { plansByName } = useTonPlans()

  const currentPlan = plansByName.get(planName || '')

  if (!currentPlan) return null

  const cardBrand = getCardBrandFromFlagsGroup(flagsGroup)

  return getPlanFeeByReceivingOptionAndFlag(
    currentPlan,
    rateFixed ? ReceivingOptions.OneBusinessDay : receivingOption,
    rateFixed ? PaymentsCard.Mastercard : cardBrand
  )
}
